import React, { createContext, useContext } from 'react';
import { MenuItem, IconButton, Menu } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import burger from '_assets/parameters/burger.svg';

const StyledMenu = withStyles({
  paper: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    borderRadius: 0,
    borderBottomWidth: 1,
    color: theme.palette.text.title,
    justifyContent: 'center',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: theme.palette.blue.lightest,
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.blue.lightest,
    },
  },
}))(MenuItem);

const MenuContext = createContext();

export function BurgerMenu({ children }) {
  const [anchorEl, setAnchorEl] = React.useState(undefined);
  const open = Boolean(anchorEl);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(undefined);
  }

  return (
    <MenuContext.Provider value={handleClose}>
      <IconButton onClick={handleClick}>
        <img src={burger} style={{ height: 30, width: 30 }} alt="Password visible logo" />
      </IconButton>
      <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {children}
      </StyledMenu>
    </MenuContext.Provider>
  );
}

function BurgerItem({ onClick, ...props }) {
  const handleClose = useContext(MenuContext);

  function handleClick(event) {
    handleClose();
    onClick?.(event);
  }

  return <StyledMenuItem {...props} onClick={handleClick} />;
}

/**
 * To use it :
 * ```
 * <BurgerMenu>
 *   <BurgerMenu.Item>My Item</BurgerMenu.Item>
 * </BurgerMenu>
 */
BurgerMenu.Item = BurgerItem;
